var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26516 8.51516C6.11872 8.66161 5.88128 8.66161 5.73484 8.51516L1.23484 4.01516C1.08839 3.86872 1.08839 3.63128 1.23484 3.48483C1.38128 3.33839 1.61872 3.33839 1.76517 3.48483L6 7.71967L10.2348 3.48484C10.3813 3.33839 10.6187 3.33839 10.7652 3.48484C10.9116 3.63128 10.9116 3.86872 10.7652 4.01516L6.26516 8.51516Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownMenu);
export default __webpack_public_path__ + "static/media/dropDownMenu.6e0c4f7c3b913877b89acf207f7d3e51.svg";
export { ForwardRef as ReactComponent };